module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
  fox.registerWidget(
    "Menu_Section",
    {
      configure: function () {
        this.registerOptions("", {
          menuItemTargetAttr: "href",
          widgets: {
            menu: {
              widget: "Widget",
              autoRender: true,
              template: "menu_section",
              embed: {
                widget: "@parent @parent",
              },
            },
          },

          handleWom: {
            highlight: {
              widget: "@this",
              event: "pageChanged",
              callback: "_handlePageChange",
            },
          },
        });

        this.callParent("configure", arguments);
      },

      running: function () {
        this.menu = this.wom1("#menu");
        this.layout = this.wom1("@parent @parent @parent");

        this.callParent("running", arguments);
      },

      _handlePageChange: function (pageData) {
        if (this.menu._indom) {
          this._highlight(pageData.section, pageData.page);

          return;
        }

        this.handleEvent(
          this.menu,
          "addedToDom",
          fox.bind(function () {
            this._highlight(pageData.section, pageData.page);
          }, this),
          { once: true, prefix: "sectionMenu" }
        );
      },

      _highlight: function (section, page) {
        this.hookWrapper("highlight", { section: section, page: page });
      },

      highlight: function (pageData) {
        var target = this.getOption("menuItemTargetAttr"),
          active = pageData.section;
        if (target === "href") {
          active = "/" + active;
        }

        fox.each(
          this.menu.dom("[" + target + "]"),
          function (link) {
            fox.dom.removeClass("active", link);
          },
          this
        );
        active = active === "/home" ? "/" : active;
        fox.dom.addClass(
          "active",
          this.menu.dom1("[" + target + '="' + active + '"]')
        );
      },
    },
    "Menu2"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/menu/section.js
// module id = 329
// module chunks = 2